/**
 * Returns the appropriate icon path based on the current theme
 * @param {string} iconName - The base name of the icon (e.g., 'heart-professional')
 * @param {string} theme - The current theme ('light' or 'dark')
 * @param {boolean} isFilled - Whether to use the filled version (for liked items)
 * @returns {string} The path to the appropriate icon
 */
export function getThemeIcon(iconName, theme, isFilled = false) {
    const basePath = `/images/${iconName}`;
    
    // Make theme comparison case-insensitive
    const normalizedTheme = theme ? theme.toLowerCase() : 'light';
    
    if (normalizedTheme === 'dark') {
        if (isFilled) {
            return `${basePath}-filled-dark.svg`;
        } else {
            return `${basePath}-dark.svg`;
        }
    } else {
        // Light theme (default)
        if (isFilled) {
            return `${basePath}-filled.svg`;
        } else {
            return `${basePath}.svg`;
        }
    }
}

/**
 * Returns the appropriate heart icon based on the current theme and like status
 * @param {string} theme - The current theme ('light' or 'dark')
 * @param {boolean} isLiked - Whether the item is liked
 * @returns {string} The path to the appropriate heart icon
 */
export function getHeartIcon(theme, isLiked) {
    return getThemeIcon('heart-professional', theme, isLiked);
}

/**
 * Returns the appropriate comments icon based on the current theme
 * @param {string} theme - The current theme ('light' or 'dark')
 * @returns {string} The path to the appropriate comments icon
 */
export function getCommentsIcon(theme) {
    return getThemeIcon('comments-professional', theme, false);
}